import { change, Field } from "redux-form";
import FormElement from "../../forms/form_element";
import { RadioInputField } from "../../lib/radio-input/radio-input";
import FileUploadV2 from "../../forms/file_upload/file_upload_v2";
import get from "lodash/get";
import QuillEditor from "../../forms/quill";
import React, { useEffect } from "react";
import {
  campaignEditorFormName,
  CampaignEditorPageFormsWrapper,
  promotionCodeValueToDisplay,
} from "./campaign_editor_helpers";
import { connect } from "react-redux";
import { DistributionTypeContinuous, DistributionTypeDiscrete } from "../../../constants/campaigns";

export let AdFormat = ({
  handleSubmit,
  mediaFiles,
  initialValues,
  validationErrors,
  changeField,
  campaign,
}) => {
  // Discrete only supports host-read campaigns
  useEffect(() => {
    if (!campaign) return;
    if (
      campaign.distributionType === DistributionTypeDiscrete &&
      campaign.style === "campaignAudio"
    ) {
      changeField("distributionType", DistributionTypeContinuous);
    }
  }, [campaign, changeField]);

  return (
    <form onSubmit={handleSubmit} id="ad-format">
      <Field
        name={"style"}
        label="Select how you'd like to be heard*"
        component={FormElement}
        InputComponent={RadioInputField}
        validationErrors={validationErrors}
        defaultValue="hostRead"
        options={[
          {
            infoText:
              "Brand uploads a pre-recorded </br>audio file that will play on all </br>shows that accept this </br>campaign.",
            display: "Pre-Recorded Ad",
            value: "campaignAudio",
            optionalFields: () => (
              <>
                <Field
                  component={FormElement}
                  InputComponent={FileUploadV2}
                  label="Upload MP3"
                  name="contentFile"
                  mediaFiles={mediaFiles}
                  mediaFileUUID={get(initialValues, "mediaFileUUIDs.128")}
                  validationErrorKeyOverride={"mediaFileUUIDs"}
                  infoText={
                    "Upload a 30-60 second audio clip promoting your podcast. <br/>This clip will be played as an intro on the recipients podcast."
                  }
                />
              </>
            ),
          },

          {
            display: "Host-Read Ad",
            infoText:
              "The podcast host will read and </br>record a 0:60 ad endorsement </br>in their own voice.",
            value: "hostRead",
            optionalFields: () => (
              <>
                <Field
                  component={FormElement}
                  name="script"
                  label="Talking Points or Script*"
                  placeholder="Provide a script and/or general talking points that you want the podcaster to say. Please make sure there’s enough information for a 0:60 sec read."
                  type="textarea"
                  InputComponent={QuillEditor}
                  validationErrors={validationErrors}
                />
                {/* TODO Need a support article on writing a great script */}
                {/*<ExternalLink className={"bold"} href={GreatScriptHelpDocURL}>*/}
                {/*  Learn how to write a great script &rarr;*/}
                {/*</ExternalLink>*/}
                <Field
                  component={FormElement}
                  name="scriptTip"
                  label="Any Requirements? (Optional)"
                  InputComponent={QuillEditor}
                  componentClass="textarea"
                  placeholder={"e.g. 60 sec minimum read"}
                  validationErrors={validationErrors}
                />
                <Field
                  component={FormElement}
                  name="promoCodeType"
                  label="campaign promotion code*"
                  componentClass={RadioInputField}
                  validationErrors={validationErrors}
                  options={[
                    {
                      value: "podcaster_unique",
                      display: promotionCodeValueToDisplay.podcaster_unique,
                      infoText:
                        "You'll be able to download a list </br>of the show's unique codes </br>from your Campaign Dashboard </br>when they accept your </br>campaign.",
                    },
                    {
                      value: "standard",
                      display: promotionCodeValueToDisplay.standard,
                      infoText:
                        "One code that you want all </br>shows to say to listeners, eg </br>NIKE20",
                    },
                    {
                      value: "none",
                      display: promotionCodeValueToDisplay.none,
                    },
                  ]}
                />
              </>
            ),
          },
        ]}
      />
    </form>
  );
};

const mapDispatchToProps = {
  changeField: (field, value) => change(campaignEditorFormName, field, value),
};

AdFormat = CampaignEditorPageFormsWrapper(connect(() => ({}), mapDispatchToProps)(AdFormat));
